import { render, staticRenderFns } from "./CompanyListView.vue?vue&type=template&id=37298fbc&"
import script from "./CompanyListView.vue?vue&type=script&lang=js&"
export * from "./CompanyListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports